export default __webpack_public_path__ + "static/solving-6a3692fee42404be2b9881da45c3f9ad.png";